/**
 * Recursively determines whether a filter value is "empty": `undefined`, `null`, `""`,
 * `false`, an empty array, or an object whose every value is itself empty by these rules.
 * Applies to a single filter value and, since it recurses, to a whole filter DTO tree.
 * Used to decide whether a saved search-filter set carries any meaningful selection (see
 * `teamHasFilters` and the leads filter chip builders).
 */
export const isFilterValueEmpty = (value: unknown): boolean => {
    if (value === undefined || value === null || value === "" || value === false) {
        return true;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    if (typeof value === "object") {
        return Object.values(value).every(isFilterValueEmpty);
    }
    return false;
};
